import withModal from 'src/hoc/withModal'

import ModalLoader from './ModalLoader'

export default withModal(ModalLoader)
